import React from 'react';
import { object, string, shape } from 'prop-types';
import { ReferralProgram } from '../../components/ReferralProgram';
import { EntryProps } from '../../../lib/interfaces';
import { RolloutContext, Rollouts, defaultRolloutContext } from '../../hooks/useRollout';
import { CampaignContext, CampaignContextInterface } from '../../hooks/useCampaign';
import { UserContext } from '../../hooks/useUser';

const ReferralProgramPage = (props: EntryProps) => {
  const { user, socialLinks, inviteLink, rollouts = defaultRolloutContext, slug = '' } = props;

  const campaign: CampaignContextInterface = {
    slug,
  };

  return (
    <RolloutContext.Provider value={rollouts as Rollouts}>
      <CampaignContext.Provider value={campaign}>
        <UserContext.Provider value={user}>
          <ReferralProgram user={user} socialLinks={socialLinks} inviteLink={inviteLink} />
        </UserContext.Provider>
      </CampaignContext.Provider>
    </RolloutContext.Provider>
  );
};

ReferralProgramPage.propTypes = {
  user: object,
  socialLinks: object,
  rollouts: shape({}),
  slug: string,
};

export default ReferralProgramPage;
